import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import customFetch from '../utils/customFetch';

export type ApiKey = {
    id: string;
    created_time: string;
    updated_time: string;
}

export const useGetAllApiKeys = () => {
  console.log(process.env.REACT_APP_BACKEND_URL);
    return useQuery<ApiKey[], ErrorEvent>({
      queryKey: ['apiKeys'],
      queryFn: () => {
        return customFetch(`/v1/apikeys`)
          .then(async(res) => {
            const data = await res.json();
            return res.ok
              ? data
              : Promise.reject(new Error('Failed to get api keys'))
          })
          .catch((err) => toast.error(err.message));
      }
    });
  }